export const LOADING = 'project/common/loading';
export const LOADED = 'project/common/loaded';
export const ERROR = 'project/common/error';
export const ADD_GROUP = 'project/common/posts/add_group';
export const ADD_POST = 'project/common/posts/add_post';
export const REMOVE_POST = 'project/common/posts/remove_post'
export const MODIFY_POST = 'project/common/posts/modify_post'
